
import React from 'react';

const benefits = [
  {
    icon: 'ri-armchair-line',
    title: 'MeVER Chair 体験',
    desc: 'コワーキングスペースの利用料のみで、MeVER Chairを実際に体験できます',
  },
  {
    icon: 'ri-time-line',
    title: '長時間の座り心地を確認',
    desc: '実際に仕事をしながら、長時間の座り心地をじっくり確認できます',
  },
  {
    icon: 'ri-map-pin-line',
    title: '新宿駅徒歩5分',
    desc: '新宿三丁目駅から徒歩2分、JR新宿駅から徒歩5分の好立地',
  },
  {
    icon: 'ri-wifi-line',
    title: '高速Wi-Fi完備',
    desc: '快適なネット環境で、ストレスなく作業に集中できます',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'フードホール直結',
    desc: '5Fのフードホールで食事やドリンクを楽しみながら仕事ができます',
  },
  {
    icon: 'ri-door-lock-line',
    title: '会議室・個人ブース',
    desc: '4つの会議室と9つの個人ブースでWeb会議も快適に',
  },
];

export default function CoworkingBenefits() {
  return (
    <section
      className="py-16 sm:py-24 md:py-32 bg-white"
      aria-labelledby="benefits-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-emerald-500/10 text-emerald-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            BENEFITS
          </span>
          <h2
            id="benefits-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            体験のメリット
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            コワーキングスペース by favy（新宿）で、MeVER Chairを体験できます
          </p>
        </div>

        <div
          className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8"
          role="list"
        >
          {benefits.map((benefit, index) => (
            <article
              key={index}
              className="group bg-gray-50 hover:bg-emerald-50/50 rounded-xl sm:rounded-2xl p-5 sm:p-7 transition-all duration-300 hover:shadow-md"
              role="listitem"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-emerald-500/10 group-hover:bg-emerald-500/20 rounded-xl mb-4 sm:mb-5 transition-colors">
                <i
                  className={`${benefit.icon} text-xl sm:text-2xl text-emerald-600`}
                  aria-hidden="true"
                ></i>
              </div>
              <h3 className="text-sm sm:text-base font-light text-black mb-1.5 sm:mb-2 tracking-wide">
                {benefit.title}
              </h3>
              <p className="text-xs sm:text-sm text-black/60 font-extralight tracking-wide leading-relaxed">
                {benefit.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
